import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { $generateHtmlFromNodes } from "@lexical/html";
import { ToolbarPlugin } from "./ToolbarPlugin";

import { ParagraphNode, TextNode } from "lexical";
import { ListNode, ListItemNode } from "@lexical/list";
import { LinkNode } from "@lexical/link";
import { LinkTargetPlugin } from "./LinkTargetPlugin";
import EditorInitializer from "./EditorInitializer";

export default function LexicalEditor({ initialValue = "", onChange }) {
	const initialConfig = {
		namespace: "MyEditor",
		onError: (error) => {
			throw error;
		},
		nodes: [ParagraphNode, TextNode, ListNode, ListItemNode, LinkNode],
	};

	const handleEditorChange = (editorState, editor) => {
		editorState.read(() => {
			const html = $generateHtmlFromNodes(editor, null);
			onChange(html); // Save HTML to parent
		});
	};

	return (
		<LexicalComposer initialConfig={initialConfig}>
			<EditorInitializer html={initialValue} />
			<ToolbarPlugin />
			<div className="position-relative">
				<RichTextPlugin
					contentEditable={
						<ContentEditable
							className="form-control bg-dark text-light"
							style={{
								minHeight: "200px",
								overflowY: "auto",
							}}
						/>
					}
					placeholder={
						<div
							className="text-muted"
							style={{
								position: "absolute",
								top: "0.50rem",
								left: "0.75rem",
								pointerEvents: "none",
							}}
						>
							Enter details for your event...
						</div>
					}
				/>
			</div>
			<HistoryPlugin />
			<OnChangePlugin onChange={handleEditorChange} />
			<ListPlugin />
			<LinkPlugin />
			<LinkTargetPlugin />
		</LexicalComposer>
	);
}
